<ng-container *transloco="let t">
  <app-page-template>
    <div class="container">
      <div class="pt-48-38 pb-300-228">
        <app-grey-card-with-title [title]="t('app.common.forgot.password')" [removeContentPaddingTop]="true">
          <div class="text-center pb-20 pt-20">
            <span>{{ t('recover.lost.password.enter.email') }}</span>
          </div>
          <div class="px-10">
            <form #requestAccountRecovery="ngForm" [formGroup]="inputForm">
              <app-input formControlName="email" label="app.common.email"/>
              <div class="row">
                <div class="col-12">
                  <div class="pt-48-38 pb-42-32">
                    <div class="d-flex justify-content-center">
                      <app-rounded-button [label]="t('recover.lost.password.account.recovery')" (onClick)="onSubmit()"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="text-center" (click)="toLogin()">
                        <span
                          class="link-button text-uppercase fw-semibold">{{ t('recover.lost.password.back.to.log.in') }}</span>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </app-grey-card-with-title>
      </div>
    </div>
  </app-page-template>
</ng-container>
